import * as React from 'react';

const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20.379} height={18.086} {...props}>
    <path
      data-name="Path 10261"
      d="m6.737 13.699 4.159-11.43a1.147 1.147 0 0 1 1.47-.686l6.938 2.523a1.147 1.147 0 0 1 .686 1.47l-4.16 11.431a1.147 1.147 0 0 1-1.47.686L7.423 15.17a1.147 1.147 0 0 1-.686-1.47Z"
      fill="#fcf7e5"
    />
    <path
      data-name="Path 10262"
      d="M13.921 8.104a1.406 1.406 0 0 0-2.7-.422c-.529 1.454 1.161 2.651 1.3 4.235v.023l.017-.015c1.127-1.123 3.191-.953 3.721-2.407a1.407 1.407 0 0 0-2.338-1.414Z"
      fill="#eb3000"
    />
    <path
      data-name="Path 10264"
      d="M1.078 2.916 8.015.392a1.147 1.147 0 0 1 1.47.686l4.16 11.43a1.147 1.147 0 0 1-.686 1.47L6.02 16.503a1.147 1.147 0 0 1-1.47-.685L.392 4.387a1.147 1.147 0 0 1 .686-1.471Z"
      fill="#fffdf4"
    />
    <path
      data-name="Path 10265"
      d="M9.579 7.817c-.517-1.421-2.617-1.479-3.718-2.576l-.016-.015v.022C5.706 6.796 4.136 8.19 4.653 9.611a1.366 1.366 0 0 0 2.576-.2 2.027 2.027 0 0 1 .137.542 5.394 5.394 0 0 1-.521 2.2 3.517 3.517 0 0 1 2.692-.98 5.565 5.565 0 0 1-1.813-1.351 3.2 3.2 0 0 1-.277-.506 1.366 1.366 0 0 0 2.135-1.5Z"
    />
  </svg>
);

export default SvgComponent;
